export default __webpack_public_path__ + "static/media/i_bus-tro_rd_tagless.14cbd967.svg";